<template>
  <el-form inline :model="criteria" size="small" label-width="110px">
    <el-form-item label="订单号：">
      <el-input v-model.trim="criteria.bizOrderNo" placeholder="请输入订单号"></el-input>
    </el-form-item>
    <el-form-item label="提单号：">
      <el-input v-model.trim="criteria.dispatchOrderNo" placeholder="请输入提单号"></el-input>
    </el-form-item>
    <el-form-item label="下单时间：">
      <el-date-picker
        v-model="criteria.orderCreate"
        type="daterange"
        align="right"
        unlink-panels
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="—"
        :default-time="['00:00:00', '23:59:59']"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      ></el-date-picker>
    </el-form-item>
    <el-form-item label="确认收货时间：">
      <el-date-picker
        v-model="criteria.orderReceived"
        type="daterange"
        align="right"
        unlink-panels
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="—"
        :default-time="['00:00:00', '23:59:59']"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      ></el-date-picker>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="startSearch">确定</el-button>
      <el-button @click="reset">清除</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
const defaultCriteria = {
  bizOrderNo: '',
  dispatchOrderNo: '',
  orderCreate: [],
  orderReceived: []
}

export default {
  name: 'ApplyDetailSearch',
  data() {
    return {
      criteria: { ...defaultCriteria }
    }
  },
  methods: {
    reset() {
      this.criteria = { ...defaultCriteria }
      this.startSearch()
    },
    startSearch() {
      const request = {}
      Object.keys(this.criteria).forEach(key => {
        if (!this.criteria[key]) {
          return
        }
        if (key === 'orderCreate' || key === 'orderReceived') {
          if (this.criteria[key].length === 2) {
            request[`${key}TimeStart`] = this.criteria[key][0]
            request[`${key}TimeEnd`] = this.criteria[key][1]
          }
        } else {
          request[key] = this.criteria[key]
        }
      })
      this.$emit('on-search', request)
    }
  }
}
</script>
